import React from "react";

export const OpenCloseContactContext = React.createContext({
  openCloseContact: false,
  setOpenCloseContact: () => {},
});
